import script from "./StudentRatingTrainers.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentRatingTrainers.vue?vue&type=script&setup=true&lang=js"

import "./StudentRatingTrainers.vue?vue&type=style&index=0&id=72c71df8&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c71df8"]])

export default __exports__